import React, { useCallback } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import DynamicBreadcrumbs from '../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs';
import { BreadcrumbContainer, CustomBreadcrumbWrapper } from './Breadcrumb.styled';
import { useAgent } from '../../context';

const Breadcrumb = () => {
  const { agentId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { agent } = useAgent();

  const handleNavigate = useCallback((href) => {
    navigate(href);
  }, [navigate]);

  const items = [{ label: 'Agents', href: '/v2/agentsView' }];

  if (agentId) {
    items.push({
      label: agent.name || 'Agent Name',
    });
  }

  return (
    <BreadcrumbContainer>
      <CustomBreadcrumbWrapper>
        <DynamicBreadcrumbs
          items={items}
          currentPath={pathname}
          onNavigate={handleNavigate}
        />
      </CustomBreadcrumbWrapper>
    </BreadcrumbContainer>
  );
};

export default Breadcrumb;

